import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import zhCN from 'element-ui/lib/locale/lang/zh-CN'
import enUS from 'element-ui/lib/locale/lang/en'
import zhLocale from './locales/zh-CN.json'
import enLocale from './locales/en-US.json'

Vue.use(VueI18n)

// 支持的语言列表
const supportedLocales = ['zh-CN', 'en-US']
const defaultLocale = 'zh-CN'

// 检测浏览器语言
function detectLanguage() {
  // 检查 sessionStorage 中是否有保存的语言选择
  const savedLang = sessionStorage.getItem('user_language')
  if (savedLang && supportedLocales.includes(savedLang)) {
    return savedLang
  }

  // 优先使用 navigator.languages（浏览器语言偏好列表）
  if (navigator.languages && navigator.languages.length > 0) {
    for (const lang of navigator.languages) {
      // 精确匹配
      if (supportedLocales.includes(lang)) {
        return lang
      }
      // 基础语言匹配（如 'zh' 匹配 'zh-CN'）
      const baseLang = lang.split('-')[0]
      const matched = supportedLocales.find(locale => locale.startsWith(baseLang))
      if (matched) {
        return matched
      }
    }
  }

  // 使用 navigator.language 作为备选
  const browserLang = navigator.language || navigator.userLanguage
  if (browserLang) {
    // 精确匹配
    if (supportedLocales.includes(browserLang)) {
      return browserLang
    }
    // 基础语言匹配
    const baseLang = browserLang.split('-')[0]
    const matched = supportedLocales.find(locale => locale.startsWith(baseLang))
    if (matched) {
      return matched
    }
  }

  // 默认返回中文
  return defaultLocale
}

// 创建 i18n 实例
const detectedLocale = detectLanguage()
const i18n = new VueI18n({
  locale: detectedLocale,
  fallbackLocale: defaultLocale,
  messages: {
    'zh-CN': {
      ...zhCN,
      ...zhLocale
    },
    'en-US': {
      ...enUS,
      ...enLocale
    }
  },
  silentTranslationWarn: process.env.NODE_ENV === 'production'
})

// 设置 Element UI 语言
ElementLocale.i18n((key, value) => i18n.t(key, value))

// 导出切换语言的方法
export function setLocale(locale) {
  if (!supportedLocales.includes(locale)) {
    console.warn(`[i18n] 不支持的语言: ${locale}，使用默认语言`)
    locale = defaultLocale
  }
  
  i18n.locale = locale
  // 保存到 sessionStorage（本次会话有效）
  sessionStorage.setItem('user_language', locale)
  
  // 更新 Element UI 语言
  if (locale === 'en-US') {
    ElementLocale.use(enUS)
  } else {
    ElementLocale.use(zhCN)
  }
}

export default i18n

